import React from 'react'
import { Card, CardBody, Col, Container, Row } from 'reactstrap'
import { P } from '../../../../AbstractElements';
import FormCard from './ValidationForm/FormCard';
import PlanHeader from './ValidationForm/PlanHeader';
export default function CreatePlansAndPricingContainer() {

    return (

        <Container fluid>
            <PlanHeader headClass='pb-4 card' title={"Plans And Pricing"} subTitle={"Create New plans and pricing"} />

            <FormCard />

        </Container>
    );
}
